function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var encode = function encode(str) {
  // Reference: https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (_, p1) {
    return String.fromCharCode(Number("0x" + p1));
  }));
};

var setHeaders = function setHeaders(xhr, headers) {
  if (headers === void 0) {
    headers = {};
  }

  Object.keys(headers).forEach(function (name) {
    headers[name] && xhr.setRequestHeader(name, headers[name]);
  });
};

var post = function post(url, data, options, callback) {
  var strData = JSON.stringify(data);

  if (typeof fetch === 'function') {
    var cb = function cb(error, data) {
      if (error) {
        return sendXhr(url, strData, options, callback);
      }

      return callback && callback.call(null, error, data);
    };

    return fetchData(url, strData, options, cb);
  }

  sendXhr(url, strData, options, callback);
};
var sendXhr = function sendXhr(url, data, options, callback) {
  var xhr = new XMLHttpRequest();
  xhr.open('post', url);
  xhr.timeout = options.timeout && options.timeout > 0 ? options.timeout : 60000;
  xhr.withCredentials = !!options.withCredentials;
  xhr.addEventListener('load', function () {
    if (xhr.readyState === 4) {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          callback(null, JSON.parse(xhr.responseText));
        } catch (err) {
          callback(err, xhr.responseText);
        }
      } else {
        callback(new Error(xhr.statusText));
      }
    }
  });
  xhr.addEventListener('timeout', function () {
    callback(new Error("timeout with " + options.timeout + "ms"));
  });
  setHeaders(xhr, options.headers);
  xhr.send(data);
};
var fetchData = function fetchData(url, data, options, callback) {
  var _options;

  if (options === void 0) {
    options = {};
  }

  if (callback === void 0) {
    callback = function callback() {};
  }

  var fetchUrl = url;
  fetch(fetchUrl, {
    keepalive: true,
    headers: _extends({}, (_options = options) === null || _options === void 0 ? void 0 : _options.headers),
    body: new Blob([data], {
      type: 'application/json'
    }),
    method: 'POST',
    credentials: 'omit'
  }).then(function (res) {
    return res.json();
  }).then(function (data) {
    if (data.success) {
      callback(null);
    } else {
      var _data$error;

      callback(new Error(((_data$error = data.error) === null || _data$error === void 0 ? void 0 : _data$error.message) || 'api error'));
    }
  });
}; // function sendBeacon(
//   url: string,
//   data: string,
//   options: RequestOptions,
//   callback: RequestCallback
// ) {
//   try {
//     const headers = options.headers || {}
//     const blob = new Blob([data], { type: ApplicationJson })
//     const platform = headers.platform || 'desktop'
//     const corsUrl = this.normalizeUrl(url, platform)
//     if (window.navigator.sendBeacon) {
//       const result = window.navigator.sendBeacon(corsUrl, blob)
//       callback(result ? null : new Error('Request failed in sendBeacon()'))
//       if (!result) {
//         this.fetchOrXhr(url, data, options)
//       }
//     } else {
//       this.fetchOrXhr(url, data, options, callback)
//     }
//   } catch (error) {
//     callback(error as Error)
//   }
// }

var defaultPatterns = [// email
{
  regexp: /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/g,
  replacer: function replacer(m) {
    return m.replace(/^(\S)(.*)(\S@.*)$/, function (_, p1, p2, p3) {
      return "" + p1 + '*'.repeat(p2.length) + p3;
    });
  }
}, // cell phone
{
  regexp: /\d{1}\d{0,5}-\d{1,14}/g,
  replacer: function replacer(m) {
    return m.replace(/^(\d+-)(\d+)(\d{4})/, function (_, p1, p2, p3) {
      return "" + p1 + '*'.repeat(p2.length) + p3;
    });
  }
}, // credit card
{
  regexp: /[1-6]\d{14,18}/g,
  replacer: function replacer(m) {
    return m.replace(/^(\d{4})(\d+)(\d{4})/, function (_, p1, p2, p3) {
      return "" + p1 + '*'.repeat(p2.length) + p3;
    });
  }
}];
function toFuzzy(str, patterns) {
  if (patterns === void 0) {
    patterns = defaultPatterns;
  }

  var source = str;
  patterns.forEach(function (pattern) {
    source = source.replace(pattern.regexp, pattern.replacer);
  });
  return source;
}

function isObject(value) {
  return Object.prototype.toString.call(value) === '[object Object]';
}
function isArray(value) {
  return Object.prototype.toString.call(value) === '[object Array]';
}
function isFunction(value) {
  return Object.prototype.toString.call(value) === '[object Function]';
}
function isNull(value) {
  return value === null || value === undefined;
}
function deepMerge(target) {
  if (target === void 0) {
    target = {};
  }

  for (var _len = arguments.length, others = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    others[_key - 1] = arguments[_key];
  }

  for (var _i = 0, _others = others; _i < _others.length; _i++) {
    var other = _others[_i];

    if (isObject(other)) {
      for (var key in other) {
        if (!Object.getPrototypeOf(other) || other.hasOwnProperty(key)) {
          var value = other[key];

          if (isObject(value)) {
            if (target[key]) {
              target[key] = deepMerge(target[key], value);
            } else {
              target[key] = deepMerge({}, value);
            }
          } else {
            target[key] = value;
          }
        }
      }
    }
  }

  return target;
}
function isBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

var BaseLogquery = /*#__PURE__*/function () {
  function BaseLogquery(options) {
    if (options === void 0) {
      options = {};
    }

    this.queue = [];
    this.options = {
      url: '',
      headers: {
        'Content-Type': 'application/json'
      },
      timeout: 15000,
      queue: undefined,
      transform: true,
      beforeRequest: function beforeRequest(options) {
        return options;
      },
      afterResponse: function afterResponse() {}
    };

    this.encode = function () {
      return '';
    };

    this.post = function () {};

    this.set(options);
  }

  var _proto = BaseLogquery.prototype;

  _proto.set = function set(options) {
    var _this = this;

    var opts = deepMerge(this.options, options);
    var interval = opts.queue && opts.queue.interval;
    clearInterval(this.timer);

    if (interval) {
      this.timer = setInterval(function () {
        _this.pushQueue();
      }, interval);
    }

    this.options = opts;
    return opts;
  };

  _proto.transform = function transform(logObj, options) {
    var logObjCopy = deepMerge({}, logObj);
    logObjCopy.logVersion = logObjCopy.hasOwnProperty('logVersion') ? logObjCopy.logVersion : 1; // logObjCopy.type === 5 && ((logObjCopy.message as Obj).system = 'optimus');

    logObjCopy.message = logObjCopy.type === 0 ? this.encode(toFuzzy(logObjCopy.message)) : this.encode(JSON.stringify(logObjCopy.message));

    if (options.transform) {
      var _logObjCopy$timestamp = logObjCopy.timestamp,
          timestamp = _logObjCopy$timestamp === void 0 ? Date.now() : _logObjCopy$timestamp,
          message = logObjCopy.message,
          userId = logObjCopy.userId,
          requestId = logObjCopy.requestId,
          logVersion = logObjCopy.logVersion,
          codeVersion = logObjCopy.codeVersion,
          others = _objectWithoutPropertiesLoose(logObjCopy, ["timestamp", "message", "userId", "requestId", "logVersion", "codeVersion"]);

      var newLogObj = _extends({
        time: timestamp,
        msg: message,
        log_ver: logVersion
      }, others);

      userId && (newLogObj.uid = userId);
      requestId && (newLogObj.req_id = requestId);
      codeVersion && (newLogObj.code_ver = codeVersion);
      return newLogObj;
    }

    return logObjCopy;
  };

  _proto.pushQueue = function pushQueue() {
    var len = this.queue.length;
    var size = this.options.queue && this.options.queue.size;

    if (size) {
      var num = Math.ceil(len / size);

      for (var i = 0; i < num; i++) {
        this.push(this.queue.splice(0, size), this.options);
      }
    } else {
      this.push(this.queue.splice(0), this.options);
    }
  };

  _proto.prePush = function prePush(logObj, options) {
    if (options === void 0) {
      options = {};
    }

    if (!isNull(logObj === null || logObj === void 0 ? void 0 : logObj.isMasked) && isNull(logObj === null || logObj === void 0 ? void 0 : logObj.is_masked) && isBrowser()) {
      logObj.is_masked = logObj.isMasked;
      logObj.isMasked = undefined;
    }

    var opts = deepMerge({}, this.options, options);

    if (!Object.keys(options).length) {
      if (opts.queue && opts.queue.interval) {
        this.queue.push(logObj);
        return;
      }
    }

    this.push(logObj, opts);
  };

  _proto.push = function push(logObj, options) {
    var _this2 = this;

    var logs = isArray(logObj) ? logObj : [logObj];
    var opts = deepMerge({}, options);

    if (!logs.length) {
      return;
    } // Setting data


    opts.data = {
      logs: logs.map(function (log) {
        return _this2.transform(log, opts);
      })
    }; // Call hook: beforeRequest

    if (opts.beforeRequest && isFunction(opts.beforeRequest)) {
      opts = opts.beforeRequest(opts);
    }

    if (!opts.url) {
      console.warn('The parameter URL is required');
      return;
    }

    this.post(opts.url, opts.data, opts, function (error, data) {
      // Call hook: afterResponse
      if (opts.afterResponse && isFunction(opts.afterResponse)) {
        opts.afterResponse(error, data);
      }

      _this2.endCallback(error, data, opts.afterResponse);
    });
  };

  _proto.endCallback = function endCallback(error, data, cb) {
    if (cb && isFunction(cb)) {
      cb(error, data);
    }
  };

  _proto.masked = function masked() {
    return;
  };

  _proto.service = function service(logObj, options) {
    logObj.type = 0;
    this.prePush(logObj, options);
  };

  _proto.business = function business(logObj, options) {
    logObj.type = 1;
    this.prePush(logObj, options);
  };

  _proto.performance = function performance(logObj, options) {
    logObj.type = 2;
    this.prePush(logObj, options);
  };

  _proto.optimus = function optimus(logObj, options) {
    logObj.type = 4;
    this.prePush(logObj, options);
  };

  _proto.general = function general(logObj, options) {
    logObj.type = 5;

    if (isObject(logObj.message) && typeof logObj.message === 'object') {
      logObj.message.system = 'optimus';

      if (!isBrowser()) {
        try {
          logObj.message = JSON.stringify(logObj.message);
        } catch (e) {
          console.warn('Stringify message Error', e);
        }
      }
    }

    this.prePush(logObj, options);
  };

  return BaseLogquery;
}();

/**
 * 小程序不支持 btoa 函数，对base64进行补充
 * 对字符串进行base64编码
 * @param str 进行编码字符串
 */
function btoa$1(str) {
  var CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  var bitmap,
      a,
      b,
      c,
      result = '',
      i = 0,
      rest = str.length % 3; // 计算余数，得知"="需要补充几位

  for (; i < str.length;) {
    a = str.charCodeAt(i++);
    b = str.charCodeAt(i++);
    c = str.charCodeAt(i++);

    if (a > 255 || b > 255 || c > 255) {
      throw new TypeError('The string to be encoded contains characters outside of the Latin1 range.');
    }

    bitmap = a << 16 | b << 8 | c;
    result += CHARS.charAt(bitmap >> 18 & 63) + CHARS.charAt(bitmap >> 12 & 63) + CHARS.charAt(bitmap >> 6 & 63) + CHARS.charAt(bitmap & 63);
  } // 补全字符串后面“=”


  return rest ? result.slice(0, rest - 3) + '==='.substring(rest) : result;
}

var encode$1 = function encode(str) {
  return btoa$1(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (_, p1) {
    return String.fromCharCode(Number("0x" + p1));
  }));
};

// 请求依赖 uni-app框架，兼容三个小程序发送请求
var post$1 = function post(url, data, options, callback) {
  // @ts-ignore
  uni.request({
    url: url,
    data: data,
    method: 'POST',
    header: options.headers
  }).then(function (result) {
    var error = result[0],
        resp = result[1];

    if (error) {
      callback(new Error(JSON.stringify(error)));
      return;
    }

    if (+resp.statusCode === 200) {
      try {
        callback(null, JSON.parse(resp));
      } catch (err) {
        callback(err, resp);
      }
    }
  })["catch"](function (err) {
    callback(err, err);
  });
};

var Logquery = /*#__PURE__*/function (_BaseLogquery) {
  _inheritsLoose(Logquery, _BaseLogquery);

  function Logquery() {
    var _this;

    _this = _BaseLogquery.apply(this, arguments) || this;
    _this.encode = encode$1;
    _this.post = post$1;
    return _this;
  }

  return Logquery;
}(BaseLogquery);

var ActionEnum;

(function (ActionEnum) {
  ActionEnum[ActionEnum["router"] = 0] = "router";
  ActionEnum[ActionEnum["controller"] = 1] = "controller";
  ActionEnum[ActionEnum["service"] = 2] = "service";
  ActionEnum[ActionEnum["render"] = 3] = "render";
  ActionEnum[ActionEnum["other"] = 4] = "other";
})(ActionEnum || (ActionEnum = {}));

var Logquery$1 = /*#__PURE__*/function (_BaseLogquery) {
  _inheritsLoose(Logquery, _BaseLogquery);

  function Logquery() {
    var _this;

    _this = _BaseLogquery.apply(this, arguments) || this;
    _this.encode = encode;
    _this.post = post;
    return _this;
  }

  return Logquery;
}(BaseLogquery);

export default Logquery$1;
export { ActionEnum, Logquery as MiniProgramLogquery, deepMerge, encode, isArray, isBrowser, isFunction, isNull, isObject, toFuzzy };
//# sourceMappingURL=browser.esm.js.map
